import { coreCapabilitiesSupportedBrowsers } from './coreCapabilitiesSupportedBrowsers';

export const coreBrowserNotSupported = (): boolean =>
	!coreCapabilitiesSupportedBrowsers.test(navigator.userAgent);
